<template>
  <AppPageCard>
    <template #card-title> Teacher Leave Assignment </template>
    <div>
      <span
        class="
          text-muted
          font-weight-bold font-size-base
          d-none d-md-inline
          mr-1
        "
      >
        {{ $t("EMPLOYEE.EMP") }}
      </span>
      <span
        class="
          text-dark-50
          font-weight-bolder font-size-base
          d-none d-md-inline
          mr-3
        "
      >
        {{ getTitle() }}
      </span>
      <IndividualEmployeeLeaveEntitlementTable
        :is-busy="isBusy"
        :items="items"
        :pagination="pagination"
        @onClickEntitlement="showModal"
      ></IndividualEmployeeLeaveEntitlementTable>

      <TeacherIndividualLeaveAssignmentModal
        :assigned-leave="form"
        :is-busy="isBusy"
        @formSubmitted="fetch"
      ></TeacherIndividualLeaveAssignmentModal>
    </div>
  </AppPageCard>
</template>

<script>
import { mapGetters } from "vuex";
import AppPageCard from "@/modules/core/components/shared/card/AppPageCard";
import IndividualEmployeeLeaveEntitlementTable from "@/modules/school/components/management/leave/entitlement/IndividualEmployeeLeaveEntitlementTable";
import TeacherIndividualLeaveAssignmentModal from "@/modules/school/components/management/leave/assignment/teacher/TeacherIndividualLeaveAssignmentModal";

export default {
  name: "TeacherIndividualLeaveAssignmentPage",
  components: {
    TeacherIndividualLeaveAssignmentModal,
    IndividualEmployeeLeaveEntitlementTable,
    AppPageCard,
  },
  data() {
    return {
      isBusy: false,
      selectedLeave: this.form ?? {},
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    getTitle() {
      return this.$route.query.name;
    },

    fetch() {
      this.isBusy = true;
      this.$store
        .dispatch("fetchTeacherIndividualEntitlementList", {
          id: this.$route.query.id,
        })
        .finally(() => (this.isBusy = false));
    },

    /**
     *
     * @param data
     */
    showModal(data) {
      console.log("Data ", data);

      this.isBusy = true;
      this.$store
        .dispatch("fetchTeacherIndividualEntitlementForm", {
          id: data.id,
        })
        .finally(() => (this.isBusy = false));

      this.$bvModal.show("leave-page-assignment-modal");
    },
  },
  computed: {
    ...mapGetters({
      items: "getTeacherIndividualEntitlementList",
      pagination: "getTeacherIndividualEntitlementListPagination",
      form: "getTeacherIndividualEntitlementForm",
    }),
  },
};
</script>

<style scoped></style>
